import type {
  PostAttachmentRequestType,
  PostAttachmentResponseType,
} from 'entities/document/api/types';
import { changeDateToStringInObject } from 'helpers/safeJsonStringify';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const postAttachment = async (params: PostAttachmentRequestType) => {
  const { documentId, attachmentId, data, ...rest } = params;
  const url = `/api/v2/documents/${documentId}/attachments/${attachmentId}`;
  const response = await apiAuthClient.patch<PostAttachmentResponseType>(url, {
    ...rest,
    data:
      data && typeof data === 'object'
        ? changeDateToStringInObject(data)
        : data,
  });

  return response.data;
};
